class AlternativesView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".alternatives-modal-button",
      handler: (e, target) => {
        e.preventDefault();

        if (this.isLoading) return;

        this.target = target;

        this.toggleLoading(true);

        this.colorScheme = target.dataset.colorScheme;
        const modalId = target.dataset.modalId;
        this.productsCount = parseInt(target.dataset.productsCount, 10);

        if (modalId) {
            const modalContent = document.querySelector('#' + modalId + ' .alternatives-modal__list');
            if (modalContent) {
                this.loadProductAlternatives(modalContent);
            }
        }
      },
    });

    window.MinimogEvents.subscribe('ON_MODAL_CLOSED', (modal) => {
      this.close();
    });
  }

  // Load product quick view HTML
  loadProductAlternatives(modalContent) {
    if (this.isOpen) {
      this.close(); // Close any existing modal before loading a new one
    }

    this.isLoading = true;

    let clonedModalContent = modalContent.cloneNode(true);

    this.modal.appendChild(clonedModalContent);

    if (this.productsCount && Number.isInteger(this.productsCount)) {
        if (this.productsCount >= 3) {
            this.modal.setWidth("960px");
        } else {
            this.modal.setWidth((this.productsCount * 310) + 'px');
        }
    } else {
        this.modal.setWidth("960px");
    }
    
    this.modal.open();
    this.modal.setSizes(`m-gradient ${this.colorScheme}`);
    this.toggleLoading(false);

    this.isOpen = true;
    this.isLoading = false; // Reset loading state

    document.dispatchEvent(
        new CustomEvent('tcustomizer-custom-show-alternative-products', {
            detail: { productHandle: this.target.dataset.productHandle }
        })
    );

    document.dispatchEvent(
        new CustomEvent("alternative-products:loaded", {
            detail: { productUrl: this.target.dataset.productHandle }
        })
    );
  }


  // Close the quick view modal
  close() {
    this.isOpen = false;
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }

  setInnerHTML(element, innerHTML) {
    element.innerHTML = '';
    element.appendChild(innerHTML);
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductAlternativesView = new AlternativesView();
